const initialState = {
    findComments: null,
    isLoadingCommentToAdd: false,
    isLoadingCommentToEdit: false,
    isLoadingCommentToDelete: false,
    editingComment: null,
    commentContentToAdd: "",
    commentContentToEdit: "",
    parseContactOnCommentToAdd: null,
    parseContactOnCommentToEdit: null,
	showUpgradeToBusinessToComment: false
};

const commentReducer = ( state = initialState, action ) => {
    switch (action.type) {
        case "FIND_COMMENTS":
            state = {
                ...state,
                findComments: action.payload
            };
            break;
	    case "FIND_NEXT_COMMENTS":
		    state = {
			    ...state,
			    findComments: {
				    ...state.findComments,
				    commentResponses: [
					    ...state.findComments.commentResponses,
					    ...action.payload.commentResponses
				    ]
			    }
		    };
		    break;
        case "IS_LOADING_COMMENT_TO_ADD":
            state = {
                ...state,
                isLoadingCommentToAdd: action.payload
            };
            break;
        case "IS_LOADING_COMMENT_TO_EDIT":
            state = {
                ...state,
                isLoadingCommentToEdit: action.payload
            };
            break;
        case "IS_LOADING_COMMENT_TO_DELETE":
            state = {
                ...state,
                isLoadingCommentToDelete: action.payload
            };
            break;
        case "EDITING_COMMENT":
            state = {
                ...state,
                editingComment: action.payload
            };
            break;
        case "COMMENT_CONTENT_TO_ADD":
            state = {
                ...state,
                commentContentToAdd: action.payload
            };
            break;
        case "COMMENT_CONTENT_TO_EDIT":
            state = {
                ...state,
                commentContentToEdit: action.payload
            };
            break;
        case "PARSE_CONTACT_ON_COMMENT_TO_ADD":
            state = {
                ...state,
                parseContactOnCommentToAdd: action.payload
            };
            break;
        case "PARSE_CONTACT_ON_COMMENT_TO_EDIT":
            state = {
                ...state,
                parseContactOnCommentToEdit: action.payload
            };
            break;
	    case "SHOW_UPGRADE_TO_BUSINESS_TO_COMMENT":
		    state = {
			    ...state,
			    showUpgradeToBusinessToComment: action.payload
		    };
		    break;
        default:
            return state;
    }
    return state;
};

export default commentReducer;
